import CertsListDiscontinue from './CertsListDiscontinue';

export default CertsListDiscontinue;
